/** Director ↔ DocuSign signer name matching.
 *  Handles Companies House "SURNAME, Forename Middle" AND plain "Forename Middle Surname" (ASIC / ABR sole traders),
 *  ignores case, punctuation, honorifics and word order: a match needs the director's surname AND first forename
 *  to appear among the signer's name words (or an identical normalised name). */
const HONORIFICS = new Set(["MR", "MRS", "MS", "MISS", "DR", "SIR", "DAME", "LORD", "LADY", "PROF"]);

export const nameWords = (s) =>
  String(s || "").toUpperCase().replace(/[^A-Z\s,'-]/g, " ").replace(/'/g, "").split(/[\s,-]+/).filter((w) => w && !HONORIFICS.has(w));

export function directorNameParts(name) {
  const raw = String(name || "").trim();
  if (!raw) return { first: "", last: "", words: [] };
  if (raw.includes(",")) {
    const [surname, forenames = ""] = raw.split(",");
    const last = nameWords(surname)[0] || "";
    const first = nameWords(forenames)[0] || "";
    return { first, last, words: [...nameWords(forenames), ...nameWords(surname)] };
  }
  const words = nameWords(raw);
  return { first: words[0] || "", last: words[words.length - 1] || "", words };
}

export function directorSignedBy(directorName, signers = []) {
  const d = directorNameParts(directorName);
  if (!d.words.length) return false;
  const dKey = [...d.words].sort().join(" ");
  return (signers || []).some((signer) => {
    const sw = nameWords(signer);
    if (!sw.length) return false;
    if ([...sw].sort().join(" ") === dKey) return true;
    const has = (w) => !!w && sw.includes(w);
    return has(d.last) && (has(d.first) || d.words.length === 1);
  });
}
